@if (tooltipDesc) {
  <div [ngStyle]="divStyles" style="position: relative">
    @if (!tooltipText) {
      <i
        [matTooltip]="tooltipDesc"
        [matTooltipPosition]="tooltipPos"
        matTooltipClass="custom-tooltip"
        class="fas fa-question-circle"
        [ngStyle]="styles"
      >
      </i>
    }
    @if (tooltipText) {
      <span
        [matTooltip]="tooltipDesc"
        [matTooltipPosition]="tooltipPos"
        [matTooltipClass]="matTooltipClass"
        [ngStyle]="styles"
        [innerHtml]="tooltipText | safeHtml"
      ></span>
    }
  </div>
}
